import React from 'react';

const AssetracIcon = ({
  src,
  size = 20,
  style = {},
  alt = '',
  ...props
}) => (
  <img
    src={src}
    alt={alt}
    width={size}
    height={size}
    style={{
      display: 'block',
      flexShrink: 0,
      objectFit: 'contain',
      ...style,
    }}
    {...props}
  />
);

export default AssetracIcon;
